import { render, staticRenderFns } from "./AdminPracticeManagers.vue?vue&type=template&id=58bb16c6"
import script from "./AdminPracticeManagers.vue?vue&type=script&lang=js"
export * from "./AdminPracticeManagers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports